export type NavChild = {
  name: string;
  link: string;
};

export type NavItem =
  | { name: string; id: string; dropdown: false; link: string }
  | { name: string; id: string; dropdown: true; children: NavChild[] };

export const navData: NavItem[] = [
  { name: 'Spaces365', id: '_spaces365', dropdown: false, link: '/spaces365-platform' },
  { name: 'Use Cases', id: '_solutions-use-cases', dropdown: false, link: '/solutions-use-cases' },
  { name: 'C-Suite', id: '_c_suite', dropdown: false, link: '/c-suite' },
  { name: 'HD Render', id: '_hdrender', dropdown: false, link: '/hd-render' },
  { name: 'Pricing', id: '_pricing', dropdown: false, link: '/pricing' },
  { name: 'Executive Brief', id: '_executive_brief', dropdown: false, link: '/executive-brief' },
  { name: 'Team', id: '_team', dropdown: false, link: '/team' },
];
